import { useDispatchModal } from '@libs/ui/ds/lib/internals/contexts/globalModalContext/hooks/useDispatchModal'
import { useReadModal } from '@libs/ui/ds/lib/internals/contexts/globalModalContext/hooks/useReadModal'
import React from 'react'

import { Modal } from '../../base/Modal'

import type { OpenSimpleModalProps } from './useSimpleModal'
import { GLOBAL_APP_SIMPLE_MODAL } from './useSimpleModal'

export const SimpleModal = () => {
  const { data, isOpen } = useReadModal<OpenSimpleModalProps>({
    name: GLOBAL_APP_SIMPLE_MODAL
  })

  const { close } = useDispatchModal<OpenSimpleModalProps>({
    name: GLOBAL_APP_SIMPLE_MODAL
  })

  return (
    <Modal opened={isOpen} onClose={close} {...data?.props}>
      {data?.content}
    </Modal>
  )
}

export * from './useSimpleModal'
